/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { PropsWithChildren } from 'react';

import { css, jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';

const MenuWrapper = ({ children }: PropsWithChildren<{}>) => (
	<div css={[menuWrapperStyles, fg('blu-7829_tab_nav_active_area_fix') && activeAreaPaddingStyles]}>
		{children}
	</div>
);

const menuWrapperStyles = css({
	display: 'var(--display-menu)',
	marginRight: token('space.050'),
});

const activeAreaPaddingStyles = css({
	marginLeft: token('space.075'),
	marginRight: token('space.negative.025'),
});

export default MenuWrapper;
